module.exports = __webpack_public_path__ + "web_static/img/smart_tv_animation_1015.a07bcee6.gif";